import {Box, Button, Typography} from "@mui/material";
import React from "react";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import assetsData from "../../test/impcatedAssets.json";
import AssetsTable from "../../../../components/charts/AssetsTable";

export default function AssetsDetails() {
    const history = useHistory();

    function handlGoBack() {
        history.goBack();
    }

    return (
        <Box sx={{marginBottom: {xs: "25%"}}}>
            <Button
                sx={{
                    background: "#78c3ae",
                    borderRadius: 4,
                    fontSize: "16px",
                    marginLeft: {xs: "8px", sm: "5px"}, // Remove marginLeft on mobile
                    alignSelf: "flex-start",

                    "&:hover": {
                        backgroundColor: "#60dbb9",
                    },
                }}
                onClick={handlGoBack}
            >
                <ArrowBackIcon sx={{color: "white"}}/>
            </Button>
            <Typography sx={{textAlign: "center", fontSize: "40px"}}>
                Impacted Assets
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: {xs: "column", sm: "row"},
                    justifyContent: "center",
                    alignItems: "center",
                    gap: {xs: 2, sm: 4},
                    mt: 4,
                    px: {xs: 1, sm: 2},
                }}
            >
                <Box
                    sx={{
                        boxShadow: 3,
                        borderRadius: 2,
                        p: {xs: 2, sm: 3},
                        bgcolor: "background.paper",
                        width: {xs: "90%", sm: "90%", md: "90%"},
                        minHeight: "100px",
                        height: "auto",
                        textAlign: "center",
                    }}
                >
                    {/*<AssetsChart assetsData={assetsData} />*/}
                    <AssetsTable data={assetsData}/>
                </Box>
            </Box>
        </Box>
    );
}
